import { render, staticRenderFns } from "./page-view-technical.vue?vue&type=template&id=f3796eee&scoped=true"
import script from "./page-view-technical.vue?vue&type=script&lang=js"
export * from "./page-view-technical.vue?vue&type=script&lang=js"
import style0 from "./page-view-technical.vue?vue&type=style&index=0&id=f3796eee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3796eee",
  null
  
)

export default component.exports